import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=603b45f9"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603b45f9')) {
      api.createRecord('603b45f9', component.options)
    } else {
      api.reload('603b45f9', component.options)
    }
    module.hot.accept("./NotAuthorized.vue?vue&type=template&id=603b45f9", function () {
      api.rerender('603b45f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/NotAuthorized.vue"
export default component.exports